<template>
  <v-snackbar 
    v-model="message.status"
    :vertical="message.vertical"
    :color="color"
    :type="message.type"
    :timeout="message.timeout"
    :right="true"
    :top="true"
  >
    <v-icon left large>
      {{ icon }}
    </v-icon>
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn 
        icon 
        @click="closeSnackbar"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
  import { mapActions } from "vuex";
  export default {
    props: {
      message: {
        type: Object,
        default: function () {
          return { 
            status: false,
            body: '',
            type: 'error',
            timeout: 2000,
            vertical: true
          }
        }
      }
    },
    data: () => ({
      typeList: []
    }),
    computed: {
      color(){
        const result = this.typeList.find(obj => {
          return obj.code === this.message.type;
        });
        return typeof result !== 'undefined' ? result.color : null;
      },
      text(){
        if(this.message.body){
          return this.message.body;
        }
        const result = this.typeList.find(obj => {
          return obj.code === this.message.type;
        })
        return typeof result !== 'undefined' ? result.text : null;
      },
      icon(){
        const result = this.typeList.find(obj => {
          return obj.code === this.message.type;
        })
        return typeof result !== 'undefined' ? result.icon : null;
      }
    },
    mounted() {
      this.typeList = [{
        code: 'success',
        color: 'green',
        text: this.$vuetify.lang.t('$vuetify.msg.getSuccess'),
        icon: 'mdi-check'
      },
      {
        code: 'warning',
        color: 'orange',
        text: this.$vuetify.lang.t('$vuetify.msg.hasWarning'),
        icon: 'mdi-alert'
      },
      {
        code: 'error',
        color: 'red',
        text: this.$vuetify.lang.t('$vuetify.msg.hasError'),
        icon: 'mdi-alert-circle-outline'
      }]
    },
    methods: {
      ...mapActions(["closeSnackbar"]),
    },
  }
</script>